<template>
  <div class="main white">
    <admin-page-title label="MEMBER LIST"></admin-page-title>

    <div class="p--50px pt--30px board">

      <div class="board__head pb--20px">
        <div class="board__head-sort clearfix">
          <admin-search type="user" />
        </div>
      </div>

      <!--
      [ 간격 옵션 : spacing--sm ]
      spacing--sm
      spacing--md
      spacing--lg

      [ 폰트크기 옵션 : font--sm ]
      font--sm
      font--md
      font--lg

      [ 보더 옵션 : 없음 ]
      .style--border
      .style--bg
      -->
      <table class="table OPTION spacing--lg style--bg font--md white">
        <thead>
          <tr>
            <th class="lv--1 w--sm">
              <form-checkbox
                v-model="selected"
                @change="selectAll"
                :true-value="true"
                :false-value="false"
              ></form-checkbox>
            </th>
            <th class="lv--2 w--sm">
              <order-link
                name="seq"
                class="board__sort"
              >
                번호
              </order-link>

            </th>
            <th class="lv--1 w--md text--left">
              <order-link
                name="userName"
                class="board__sort"
              >
                이름
              </order-link>
            </th>
            <th class="lv--1 text--left">이메일</th>
            <th class="lv--1 w--xl text--left">아이디</th>
            <th class="lv--1 w--sm">
              <order-link
                name="useFlag"
                class="board__sort"
              >
                상태
              </order-link>
            </th>
            <th class="lv--1 w--lg">
              <order-link
                name="emailFlag"
                class="board__sort"
              >
                이메일 수신
              </order-link>
            </th>
            <th class="lv--1 w--md">
              <order-link
                name="role"
                class="board__sort"
              >
                레벨
              </order-link>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            :key="row.userId"
            v-for="row in users.rows"
          >
            <td class="lv--1 w--sm">
              <form-checkbox
                v-model="row.selected"
                :true-value="true"
                :false-value="false"
              ></form-checkbox>
              <!-- <p v-else-if="currentRow === row.seq">></p> -->

            </td>
            <td class="lv--2 w--sm">{{row.seq}}</td>
            <td>
              <router-link :to="{name: 'adminMemberEdit', params: {'userId': row.userId}}">{{row.userName}}</router-link>
            </td>
            <td class="text--left">{{row.email}}</td>
            <td class="text--left">{{row.userId}}</td>
            <td class="text--center">
              <div
                class="event event--label-text"
                :class="row.useFlag === 'Y' ? 'event--yes' : ''"
              >{{row.useFlag | useFlag}}</div>
            </td>
            <td class="text--center">
              <div
                class="event event--label-text"
                :class="row.emailFlag === 'Y' ? 'event--yes' : ''"
              >{{row.emailFlag | emailFlag}}</div>
            </td>
            <td class="text--center">
              <div
                class="level border"
                :class="row.role | roleClass"
              >{{row.role | role}} </div>
            </td>

          </tr>
        </tbody>
      </table>

      <div class="text--center pt--30px">
        <pagination :total="users.count" />
      </div>

      <div class="text--right pt--30px clearfix">
        <form-button
          label="삭제"
          class="btn btn--xxxl border btn--md border--gray border--lighten-2 float--left"
          @click="removeSelected"
        ></form-button>
        <div class="float--right">
          <form-button
            label="엑셀 다운로드"
            class="btn btn--xxxl border btn--md border--gray border--lighten-2 mr--8px"
            @click="excelDownload"
          ></form-button>
          <form-button
            label="회원등록"
            class="btn btn--xxxl black text--white"
            @click="$router.push({name: 'adminMemberCreate'})"
          ></form-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data () {
    return {
      selected: false,
      users: {
        count: 0,
        rows: []
      }
    }
  },
  created () {
    this.search()
  },
  computed: {
    forAll () {
      return this.$route.query.useFlag !== 'N'
    }
  },
  methods: {
    async search () {
      this.users = await this.$search('/api/users')
    },
    async removeSelected () {
      const ret = await this.$removeSelected((row) => `/api/users/${row.userId}`, this.users.rows)
      ret && await this.search()
    },
    async selectAll () {
      this.selected = !this.selected
      this.users.rows = await this.$selectAll(this.users.rows, this.selected)
    },
    async excelDownload () {
      const filename = `users_${moment(new Date()).format('YYYY-MM-DD')}.xlsx`

      const params = {
        ...this.$utils.params('order'),
        ...this.$utils.params('orderType'),
        ...this.$utils.params('search'),
        ...this.$utils.params('searchType'),
        ...this.$utils.params('useFlag')
      }
      try {
        const res = await this.$http.get(`/api/users/excel/download`, { params, responseType: 'blob' })
        var newBlob = new Blob([res.data])
        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob, filename)
          return
        }
        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob)
        var link = document.createElement('a')
        link.href = data
        link.download = filename
        link.click()
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data)
        }, 100)
      } catch (ex) {
        console.log(ex)
      }
    }
  },
  components: {
    AdminSearch: () => import('../component/AdminSearch'),
    AdminPageTitle: () => import('../component/AdminPageTitle'),
    Pagination: () => import('@/component/ui2/pagination/Pagination'),
    FormCheckbox: () => import('@/component/ui2/form/FormCheckbox'),
    FormButton: () => import('@/component/ui2/button/FormButton'),
    OrderLink: () => import('@/component/search/OrderLink')
  }
}
</script>
